import React from 'react';

import i18n from '../../i18n';

// @mui
import { TableCell } from '@mui/material';


import Label from '../../components/label';

export default class GridCheckboxCell extends React.Component {
    render() {
        // props: value, id, field
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {/* "No" is a neutral answer (not archived, not a system
                    role), not a failure: default rather than error red. */}
                <Label color={this.props.value ? 'success' : 'default'} dot="solid">
                    {this.props.value
                        ? i18n.t('values.yes')
                        : i18n.t('values.no')}
                </Label>
            </TableCell>
        );
    }
}
